import { useAuth } from '@/hooks/useAuth'
import { useMemo } from 'react'
import { $api } from '../typedClient'

export function useAvailableTenants() {
  const { user } = useAuth()

  // A list of all tenant metadata (excluding Gravitate)
  const { data: tenantMetadata, isLoading: isLoadingTenants } = $api.useQuery(
    'post',
    '/meta/tenant/all',
    { params: { header: { 'X-Tenant-Name': 'Gravitate' } } },
    {
      enabled: !!user,
      select: (tenants) =>
        tenants.filter((tenants) => tenants.name !== 'Gravitate'),
    },
  )

  const { data: allowedTenants, isLoading: isAllowedTenantsLoading } =
    $api.useQuery('post', '/meta/tenant/available', {
      enabled: !!user,
    })

  const availableTenants = useMemo(() => {
    return tenantMetadata?.filter((x) => allowedTenants?.includes(x.name)) || []
  }, [allowedTenants, tenantMetadata])

  return {
    availableTenants,
    isLoadingTenants: isLoadingTenants || isAllowedTenantsLoading,
  }
}
